export const CREATE_TRANSACTION_PRICING_OFFER = gql`
    mutation createTransactionPricingOffer($input: CreateTransactionPricingOfferInput) {
        createTransactionPricingOffer(input: $input) {
            id
            offerName
            revenueShare
        }
    }
`;
